import { PluginKey } from 'prosemirror-state';
export var pluginKey = new PluginKey('breakoutPlugin');
export var getPluginState = function (state) { return pluginKey.getState(state); };
//# sourceMappingURL=plugin-key.js.map